import { ProviderCollectionInvoiceDraftValidationMessage } from '@enter/core';

/**
 * What a draft-invoice validation message asks the operator to do. The backend sends free text plus
 * an `error` flag, so the kind is read from both — and the Resolve Invoice chips and the Needs-table
 * row action must agree on it, which is why this is one function rather than two keyword lists.
 */
export type DraftMessageKind = 'error' | 'ambiguous' | 'payments' | 'review';

// A possible duplicate or unreversed payment is a payment-integrity problem, not an allocation task:
// applying it would credit the patient twice for one payment. It reads as an error even when the
// backend leaves `error` unset, because its text mentions "payment" and would otherwise land under
// "Unallocated patient payments" (FE-131).
const PAYMENT_INTEGRITY = /\b(duplicate|unreversed)\b/;

export const draftMessageKind = (m: ProviderCollectionInvoiceDraftValidationMessage): DraftMessageKind => {
    const lower = (m.message || '').trim().toLowerCase();
    if (m.error || PAYMENT_INTEGRITY.test(lower)) return 'error';
    if (lower.includes('ambiguous')) return 'ambiguous';
    if (lower.includes('unallocated') || lower.includes('payment')) return 'payments';
    return 'review';
};
